<template>
  <a v-if="canShow()" :href="brandDetails.download.play" target="_blank">
    <img
      src="@/assets/play-store.svg"
      alt="appstore"
      class="track-click"
      :width="width"
      height="auto"
      @click="trackAnchorClick"
      :class="{ 'va-base': brandDetails.mobileAppQr }"
    />
  </a>
</template>
<script>
import brand from "@/helpers/brand";
import { isAndroidDevice } from "@/helpers/userAgent";
import { trackDownloadNativeAppsButtonClick } from "@/telemetry/mailboxNudgeEvents";

export default {
  name: "AndroidDownloadButton",
  data: () => {
    return {
      brandDetails: brand.getDetails(),
    };
  },
  props: {
    checkCompatibility: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 170,
    },
    /** Analytics: which surface hosts the button. */
    sourceHook: {
      type: String,
      default: "control_panel_tab",
    },
  },
  methods: {
    canShow() {
      if (!this.brandDetails.download.play) return false;
      if (this.checkCompatibility) return isAndroidDevice();
      return true;
    },
    trackAnchorClick() {
      // button_name was historically "app_store" here (swapped with the
      // Apple button) — corrected to "play_store" per the nudge spec.
      trackDownloadNativeAppsButtonClick({
        buttonName: "play_store",
        sourceHook: this.sourceHook,
        viewSection: "desktop_and_mobile",
      });
    },
  },
};
</script>
